import { COBStep } from "../../../ClientOnboarding.utils";
import { AdditionalTerms } from "./AdditionalTerms/AdditionalTerms";
import { Introduction } from "./Introduction/Introduction";
import { IntroVideo } from "./IntroVideoStep/IntroVideo";
import { SelectAPackage } from "./SelectAPackage";
import { TermsOfService } from "./TermsOfService/TermsOfService";
import { jsx as _jsx } from "react/jsx-runtime";
export const StepContent = _ref => {
  let {
    currentStep
  } = _ref;
  switch (currentStep) {
    case COBStep.introduction:
      return /*#__PURE__*/_jsx(Introduction, {});
    case COBStep.introVideo:
      return /*#__PURE__*/_jsx(IntroVideo, {});
    case COBStep.selectAPackage:
      return /*#__PURE__*/_jsx(SelectAPackage, {});
    case COBStep.termsOfService1:
    case COBStep.termsOfService2:
    case COBStep.termsOfService3:
    case COBStep.termsOfService4:
      return /*#__PURE__*/_jsx(TermsOfService, {
        currentStep: currentStep
      });
    case COBStep.approveTerms:
      return /*#__PURE__*/_jsx(AdditionalTerms, {});
    default:
      return null;
  }
};